import { appHttpRequest } from '@/utils/AppHttpRequest';
import { IPage } from '@/types/FmsTypes';
import { ISCMPurchasePoDetail } from './scmPurchasePoType';

export interface ISCMPage<T, S> extends IPage<T> {
	statistics: S;
}

class PurchasePoService {
	// 采购单
	async one(id: string) {
		const apiUrl = `/scm2/purchase/po/findByIdOrCode/${id}`;
		return await appHttpRequest.get<ISCMPurchasePoDetail>(apiUrl);
	}
}

export const purchasePoService = new PurchasePoService();
